document.addEventListener('DOMContentLoaded', function() {
  // Variables globales
  const formAddToCart = document.querySelector('form[action="/cart/add"]');
  const cartOverlay = document.querySelector('#cartOverlay');
  const cartContent = document.querySelector('#cartContent');
  const qtyInput = document.querySelector('#quantity');
  const qtyDecrease = document.querySelector('.quantity-decrease');
  const qtyIncrease = document.querySelector('.quantity-increase');
  const addToCartButton = document.querySelector('#AddToCart');
  const buyNowButton = document.querySelector('.buy-now-button');

  // GESTION DES IMAGES RESPONSIVE ET ZOOM
  const mainImage = document.querySelector('.product-featured-image');
  const thumbnails = document.querySelectorAll('.thumbnail-item');
  const imageZoomModal = document.querySelector('#imageZoomModal');
  const zoomImage = document.querySelector('.zoom-image');
  const zoomClose = document.querySelector('.zoom-close');

  

  // Fonction pour changer l'image principale avec srcset
  function updateMainImage(thumbnail) {
    const img = thumbnail.querySelector('img');
    const largeSrc = img.getAttribute('data-large-src');
    const srcset = img.getAttribute('data-srcset');
    
    if (mainImage && largeSrc) {
      // Précharger l'image en haute qualité
      const preloadImg = new Image();
      preloadImg.onload = function() {
        mainImage.src = largeSrc;
        if (srcset) {
          mainImage.srcset = srcset;
        }
      };
      preloadImg.src = largeSrc;
      
      // Mettre à jour les classes actives
      thumbnails.forEach(t => t.classList.remove('active'));
      thumbnail.classList.add('active');
    }
  }

  

  // MINIATURES avec amélioration de la qualité
  thumbnails.forEach(thumb => {
    thumb.addEventListener('click', function() {
      updateMainImage(this);
    });
  });

  // Fonction de zoom d'image
  if (mainImage && imageZoomModal) {
    mainImage.addEventListener('click', function() {
      if (zoomImage) {
        // Utiliser la plus haute résolution disponible pour le zoom
        const currentSrcset = this.srcset;
        let highestResolutionSrc = this.src;
        
        if (currentSrcset) {
          const srcsetArray = currentSrcset.split(',');
          // Prendre la dernière (plus haute résolution)
          const highestRes = srcsetArray[srcsetArray.length - 1].trim().split(' ')[0];
          highestResolutionSrc = highestRes;
        }
        
        zoomImage.src = highestResolutionSrc;
        imageZoomModal.style.display = 'block';
      }
    });
  }

  // Fermer le modal de zoom
  if (zoomClose) {
    zoomClose.addEventListener('click', function() {
      if (imageZoomModal) {
        imageZoomModal.style.display = 'none';
      }
    });
  }

  // Fermer le modal en cliquant en dehors
  if (imageZoomModal) {
    imageZoomModal.addEventListener('click', function(e) {
      if (e.target === this) {
        this.style.display = 'none';
      }
    });
  }

  // PRELOADING DES IMAGES
  function preloadProductImages() {
    const imageUrls = [];
    thumbnails.forEach(thumb => {
      const img = thumb.querySelector('img');
      const largeSrc = img.getAttribute('data-large-src');
      if (largeSrc) {
        imageUrls.push(largeSrc);
      }
    });
    
    // Précharger les images en arrière-plan
    imageUrls.forEach(url => {
      const img = new Image();
      img.src = url;
    });
  }

  // Démarrer le préchargement après un court délai
  setTimeout(preloadProductImages, 500);

  // ONGLETS
  const tabItems = document.querySelectorAll('.tab-item');
  const tabContents = document.querySelectorAll('.tab-content');

  tabItems.forEach(tab => {
    tab.addEventListener('click', function() {
      const tabId = this.getAttribute('data-tab');
      tabItems.forEach(item => item.classList.remove('active'));
      tabContents.forEach(content => content.classList.remove('active'));
      this.classList.add('active');
      document.getElementById(tabId).classList.add('active');
    });
  });

  // SÉLECTEUR DE QUANTITÉ
  function updateAddToCartButtonState() {
    if (!addToCartButton || !qtyInput) return;
    
    const quantity = parseInt(qtyInput.value, 10);
    const isDisabled = addToCartButton.hasAttribute('disabled');
   
   if (quantity <= 0 || isDisabled) {
     addToCartButton.classList.add('disabled');
     addToCartButton.disabled = true;
   } else {
     addToCartButton.classList.remove('disabled');
     addToCartButton.disabled = false;
   }
 }

 if (qtyDecrease && qtyInput) {
   qtyDecrease.addEventListener('click', function() {
     const currentQty = parseInt(qtyInput.value, 10);
     const minQty = parseInt(qtyInput.getAttribute('min'), 10) || 1;
     if (currentQty > minQty) {
       qtyInput.value = currentQty - 1;
       updateAddToCartButtonState();
     }
   });
 }

 if (qtyIncrease && qtyInput) {
   qtyIncrease.addEventListener('click', function() {
     const currentQty = parseInt(qtyInput.value, 10);
     const maxQty = parseInt(qtyInput.getAttribute('max'), 10) || 999;
     if (currentQty < maxQty) {
       qtyInput.value = currentQty + 1;
       updateAddToCartButtonState();
     }
   });
 }

 if (qtyInput) {
   qtyInput.addEventListener('input', function() {
     const value = parseInt(this.value, 10);
     const min = parseInt(this.getAttribute('min'), 10) || 1;
     const max = parseInt(this.getAttribute('max'), 10) || 999;
     
     if (value < min) this.value = min;
     if (value > max) this.value = max;
     
     updateAddToCartButtonState();
   });
 }

 // ACCORDÉONS
 const accordionHeaders = document.querySelectorAll('.accordion-header');
 
 accordionHeaders.forEach(header => {
   header.addEventListener('click', function() {
     const accordionItem = this.parentNode;
     const accordionContent = accordionItem.querySelector('.accordion-content');
     const chevronIcon = this.querySelector('.chevron-icon');
     
     // Fermer tous les autres accordéons
     accordionHeaders.forEach(otherHeader => {
       if (otherHeader !== this) {
         const otherItem = otherHeader.parentNode;
         const otherContent = otherItem.querySelector('.accordion-content');
         const otherChevron = otherHeader.querySelector('.chevron-icon');
         
         otherItem.classList.remove('active');
         otherContent.style.maxHeight = null;
         if (otherChevron) {
           otherChevron.style.transform = 'rotate(0deg)';
         }
       }
     });
     
     // Basculer l'accordéon actuel
     if (accordionItem.classList.contains('active')) {
       accordionItem.classList.remove('active');
       accordionContent.style.maxHeight = null;
       if (chevronIcon) {
         chevronIcon.style.transform = 'rotate(0deg)';
       }
     } else {
       accordionItem.classList.add('active');
       accordionContent.style.maxHeight = accordionContent.scrollHeight + 'px';
       if (chevronIcon) {
         chevronIcon.style.transform = 'rotate(180deg)';
       }
     }
   });
 });

 // SÉLECTION DES VARIANTS
 const optionValues = document.querySelectorAll('.option-value');
 
 optionValues.forEach(option => {
   option.addEventListener('click', function() {
     const optionName = this.closest('.option-selector').querySelector('.option-name').textContent;
     const optionValue = this.getAttribute('data-value');
     
     // Mettre à jour l'interface
     this.closest('.option-values').querySelectorAll('.option-value').forEach(opt => {
       opt.classList.remove('selected');
     });
     this.classList.add('selected');
     
     // Trouver la variante correspondante et mettre à jour le formulaire
     updateVariantSelection();
   });
 });

 function updateVariantSelection() {
   const selectedOptions = {};
   
   document.querySelectorAll('.option-selector').forEach(selector => {
     const optionName = selector.querySelector('.option-name')?.textContent;
     const selectedOption = selector.querySelector('.option-value.selected');
     if (optionName && selectedOption) {
       selectedOptions[optionName] = selectedOption.getAttribute('data-value');
     }
   });
   
   // Ici, vous devrez implémenter la logique pour trouver la variante correspondante
   // et mettre à jour l'ID de variante dans le formulaire
   console.log('Options sélectionnées:', selectedOptions);
 }

 // AJOUT AU PANIER AVEC AJAX
 // AJOUT AU PANIER AVEC AJAX ET MISE À JOUR AUTOMATIQUE
if (formAddToCart) {
  formAddToCart.addEventListener('submit', function(e) {
    e.preventDefault();
    
    const formData = new FormData(this);
    const addToCartBtn = this.querySelector('#AddToCart');
    const originalText = addToCartBtn.querySelector('.cart-text').textContent;
    
    // Désactiver le bouton et changer le texte
    addToCartBtn.disabled = true;
    addToCartBtn.querySelector('.cart-text').textContent = 'Ajout...';
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && data.status === 422) {
        throw new Error(data.description || 'Erreur lors de l\'ajout au panier');
      }
      
      // Succès - mettre à jour le panier automatiquement
      addToCartBtn.querySelector('.cart-text').textContent = 'Ajouté !';
      showSuccessMessage('Produit ajouté au panier avec succès !');
      
      // Mettre à jour le contenu complet du panier
      updateCartContent();
      
      // Remettre le texte original après 2 secondes
      setTimeout(() => {
        addToCartBtn.querySelector('.cart-text').textContent = originalText;
        addToCartBtn.disabled = false;
      }, 2000);
    })
    .catch(error => {
      console.error('Erreur:', error);
      addToCartBtn.querySelector('.cart-text').textContent = 'Erreur';
      showErrorMessage(error.message || 'Erreur lors de l\'ajout au panier');
      
      setTimeout(() => {
        addToCartBtn.querySelector('.cart-text').textContent = originalText;
        addToCartBtn.disabled = false;
      }, 2000);
    });
  });
}

// BOUTON ACHETER MAINTENANT AVEC MISE À JOUR
if (buyNowButton) {
  buyNowButton.addEventListener('click', function(e) {
    e.preventDefault();
    
    if (!formAddToCart) return;
    
    const formData = new FormData(formAddToCart);
    const originalText = this.textContent;
    
    this.disabled = true;
    this.textContent = 'Redirection...';
    
    fetch('/cart/add.js', {
      method: 'POST',
      body: formData
    })
    .then(response => response.json())
    .then(data => {
      if (data.status && data.status === 422) {
        throw new Error(data.description || 'Erreur lors de l\'ajout au panier');
      }
      
      // Mettre à jour le panier avant la redirection
      updateCartContent().then(() => {
        // Rediriger vers le checkout après la mise à jour
        window.location.href = '/checkout';
      });
    })
    .catch(error => {
      console.error('Erreur:', error);
      this.textContent = 'Erreur';
      showErrorMessage(error.message || 'Erreur lors de l\'ajout au panier');
      
      setTimeout(() => {
        this.textContent = originalText;
        this.disabled = false;
      }, 2000);
    });
  });
}

// FONCTION DE MISE À JOUR COMPLÈTE DU CONTENU DU PANIER
async function updateCartContent() {
  try {
    // Récupérer les données du panier
    const cartResponse = await fetch('/cart.js');
    const cart = await cartResponse.json();
    
    // Mettre à jour les compteurs
    updateCartCounters(cart.item_count);
    
    // Mettre à jour le sous-total et total
    updateCartTotals(cart.total_price);
    
    // Mettre à jour les articles du panier
    await updateCartItems(cart);
    
    // Gérer l'affichage panier vide/plein
    toggleCartEmptyState(cart.item_count === 0);
    
  } catch (error) {
    console.error('Erreur lors de la mise à jour du panier:', error);
  }
}

// METTRE À JOUR LES COMPTEURS
function updateCartCounters(itemCount) {
  // Compteur dans l'en-tête
  const cartCount = document.getElementById('cartCount');
  if (cartCount) {
    cartCount.textContent = itemCount;
  }
  
  // Compteur dans le panier
  const cartItemCount = document.getElementById('cartItemCountText');
  if (cartItemCount) {
    cartItemCount.textContent = `${itemCount} article${itemCount > 1 ? 's' : ''}`;
  }
}

// METTRE À JOUR LES TOTAUX
function updateCartTotals(totalPrice) {
  const cartSubtotal = document.getElementById('cartSubtotal');
  const cartTotal = document.getElementById('cartTotal');
  
  if (cartSubtotal) {
    cartSubtotal.textContent = formatMoney(totalPrice);
  }
  
  if (cartTotal) {
    cartTotal.textContent = formatMoney(totalPrice);
  }
}

// METTRE À JOUR LES ARTICLES DU PANIER
async function updateCartItems(cart) {
  const cartItemsContainer = document.getElementById('cartItems');
  if (!cartItemsContainer) return;
  
  if (cart.items.length === 0) {
    // Panier vide
    cartItemsContainer.innerHTML = `
      <div class="cart-empty" id="cartEmpty">
        <div class="cart-empty-content">
          <div class="cart-empty-icon">
            <i class="fas fa-shopping-bag"></i>
            <div class="icon-decoration"></div>
          </div>
          <div class="cart-empty-text">
            <h3>Votre panier est vide</h3>
            <p>Découvrez nos produits sélectionnés avec soin pour vous</p>
          </div>
          <a href="/collections/all" class="cart-btn view-cart-btn">
            <span>Explorer nos produits</span>
            <i class="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>
    `;
  } else {
    // Construire le HTML des articles
    let itemsHTML = '';
    
    cart.items.forEach(item => {
      const itemImage = item.image ? 
        `<img src="${item.image.replace('.jpg', '_80x80.jpg').replace('.png', '_80x80.png')}" alt="${item.product_title}">` :
        '<div class="no-image">Pas d\'image</div>';
      
      const itemVariant = item.variant_title && item.variant_title !== 'Default Title' ? 
        `<div class="item-variant">${item.variant_title}</div>` : '';
      
      itemsHTML += `
        <div class="cart-item" data-key="${item.key}">
          <div class="item-image">
            ${itemImage}
          </div>
          <div class="item-details">
            <div class="item-name">${item.product_title}</div>
            ${itemVariant}
            <div class="item-price">${formatMoney(item.price)}</div>
            <div class="quantity-controls">
              <button class="quantity-btn" onclick="updateCartItemQuantity('${item.key}', ${item.quantity - 1})">
                <i class="fa-solid fa-minus"></i>
              </button>
              <span class="quantity-display">${item.quantity}</span>
              <button class="quantity-btn" onclick="updateCartItemQuantity('${item.key}', ${item.quantity + 1})">
                <i class="fa-solid fa-plus"></i>
              </button>
            </div>
          </div>
          <button class="remove-item" onclick="removeCartItem('${item.key}')">
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>
      `;
    });
    
    cartItemsContainer.innerHTML = itemsHTML;
  }
}

// GÉRER L'AFFICHAGE PANIER VIDE/PLEIN
function toggleCartEmptyState(isEmpty) {
  const cartFooter = document.getElementById('cartFooter');
  
  if (cartFooter) {
    cartFooter.style.display = isEmpty ? 'none' : 'block';
  }
}

// FONCTIONS DE GESTION DES QUANTITÉS AVEC MISE À JOUR
async function updateCartItemQuantity(key, quantity) {
  try {
    const response = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({
        id: key,
        quantity: Math.max(0, quantity)
      })
    });
    
    if (response.ok) {
      // Mettre à jour le contenu du panier au lieu de recharger la page
      await updateCartContent();
    }
  } catch (error) {
    console.error('Erreur lors de la mise à jour:', error);
    showErrorMessage('Erreur lors de la mise à jour de la quantité');
  }
}

// FONCTION DE SUPPRESSION AVEC MISE À JOUR
async function removeCartItem(key) {
  await updateCartItemQuantity(key, 0);
}

// FONCTION DE FORMATAGE DE PRIX
function formatMoney(cents) {
  const amount = cents / 100;
  return new Intl.NumberFormat('fr-FR', {
    style: 'currency',
    currency: 'EUR'
  }).format(amount);
}

// FONCTION ALTERNATIVE SI LE FORMAT MONEY SHOPIFY EST NÉCESSAIRE
function formatMoneyShopify(cents) {
  // Utiliser le format Shopify si disponible
  if (typeof Shopify !== 'undefined' && Shopify.formatMoney) {
    return Shopify.formatMoney(cents);
  }
  // Sinon utiliser notre fonction de formatage
  return formatMoney(cents);
}
 // BOUTON ACHETER MAINTENANT
 if (buyNowButton) {
   buyNowButton.addEventListener('click', function(e) {
     e.preventDefault();
     
     if (!formAddToCart) return;
     
     const formData = new FormData(formAddToCart);
     const originalText = this.textContent;
     
     this.disabled = true;
     this.textContent = 'Redirection...';
     
     fetch('/cart/add.js', {
       method: 'POST',
       body: formData
     })
     .then(response => response.json())
     .then(data => {
       if (data.status && data.status === 422) {
         throw new Error(data.description || 'Erreur lors de l\'ajout au panier');
       }
       
       // Rediriger vers le checkout
       window.location.href = '/checkout';
     })
     .catch(error => {
       console.error('Erreur:', error);
       this.textContent = 'Erreur';
       showErrorMessage(error.message || 'Erreur lors de l\'ajout au panier');
       
       setTimeout(() => {
         this.textContent = originalText;
         this.disabled = false;
       }, 2000);
     });
   });
 }

 // FONCTIONS UTILITAIRES
 function updateCartCount() {
   fetch('/cart.js')
     .then(response => response.json())
     .then(cart => {
       const cartCounters = document.querySelectorAll('.cart-count');
       cartCounters.forEach(counter => {
         counter.textContent = cart.item_count;
       });
     })
     .catch(error => console.error('Erreur mise à jour compteur panier:', error));
 }

 function showSuccessMessage(message) {
   const notification = document.createElement('div');
   notification.className = 'notification success';
   notification.textContent = message;
   document.body.appendChild(notification);
   
   setTimeout(() => {
     notification.classList.add('show');
   }, 100);
   
   setTimeout(() => {
     notification.classList.remove('show');
     setTimeout(() => {
       document.body.removeChild(notification);
     }, 300);
   }, 3000);
 }

 function showErrorMessage(message) {
   const notification = document.createElement('div');
   notification.className = 'notification error';
   notification.textContent = message;
   document.body.appendChild(notification);
   
   setTimeout(() => {
     notification.classList.add('show');
   }, 100);
   
   setTimeout(() => {
     notification.classList.remove('show');
     setTimeout(() => {
       document.body.removeChild(notification);
     }, 300);
   }, 3000);
 }

 // GESTION DU CLAVIER POUR L'ACCESSIBILITÉ
 document.addEventListener('keydown', function(e) {
   // Fermer le modal de zoom avec Escape
   if (e.key === 'Escape' && imageZoomModal && imageZoomModal.style.display === 'block') {
     imageZoomModal.style.display = 'none';
   }
 });

 // OPTIMISATION DE LA PERFORMANCE - LAZY LOADING DES IMAGES
 if ('IntersectionObserver' in window) {
   const imageObserver = new IntersectionObserver((entries, observer) => {
     entries.forEach(entry => {
       if (entry.isIntersecting) {
         const img = entry.target;
         const src = img.getAttribute('data-src');
         if (src) {
           img.src = src;
           img.removeAttribute('data-src');
           observer.unobserve(img);
         }
       }
     });
   });

   // Observer les images qui ont l'attribut data-src
   document.querySelectorAll('img[data-src]').forEach(img => {
     imageObserver.observe(img);
   });
 }

 // INITIALISATION FINALE
 updateAddToCartButtonState();
 
});

// STYLES CSS POUR LES NOTIFICATIONS
const notificationStyles = `
.notification {
 position: fixed;
 top: 20px;
 right: 20px;
 padding: 15px 20px;
 border-radius: 5px;
 color: white;
 font-weight: 500;
 z-index: 9999;
 transform: translateX(100%);
 transition: transform 0.3s ease;
 max-width: 300px;
}

.notification.show {
 transform: translateX(0);
}

.notification.success {
 background-color: #10b981;
}

.notification.error {
 background-color: #ef4444;
}

.image-zoom-modal {
 position: fixed;
 top: 0;
 left: 0;
 width: 100%;
 height: 100%;
 background: rgba(0, 0, 0, 0.9);
 z-index: 9998;
 display: flex;
 align-items: center;
 justify-content: center;
}

.zoom-overlay {
 position: relative;
 max-width: 90%;
 max-height: 90%;
}

.zoom-image {
 max-width: 100%;
 max-height: 100%;
 object-fit: contain;
}

.zoom-close {
 position: absolute;
 top: -40px;
 right: 0;
 background: none;
 border: none;
 color: white;
 font-size: 30px;
 cursor: pointer;
 line-height: 1;
}

.zoom-close:hover {
 opacity: 0.7;
}
`;

// Injecter les styles
if (!document.querySelector('#product-template-styles')) {
 const styleSheet = document.createElement('style');
 styleSheet.id = 'product-template-styles';
 styleSheet.textContent = notificationStyles;
 document.head.appendChild(styleSheet);
}


// Script pagination tactile mobile - À ajouter à votre JavaScript existant
document.addEventListener('DOMContentLoaded', function() {
    // Variables pour la pagination tactile mobile
    let currentImageIndex = 0;
    let totalImages = 0;
    let startX = 0;
    let isSwipping = false;
    const swipeThreshold = 50; // Pixels minimum pour déclencher le swipe
    
    // Récupérer les éléments existants
    const thumbnails = document.querySelectorAll('.thumbnail-item');
    const mainImage = document.querySelector('.product-featured-image');
    
    totalImages = thumbnails.length;
    
    // Fonction pour vérifier si on est sur mobile
    function isMobile() {
        return window.innerWidth <= 768;
    }
    
    // Initialiser la pagination tactile seulement sur mobile
    function initMobileTouchPagination() {
        if (!isMobile() || totalImages <= 1 || !mainImage) {
            return;
        }
        
        // Ajouter les événements tactiles
        mainImage.addEventListener('touchstart', handleTouchStart, { passive: true });
        mainImage.addEventListener('touchmove', handleTouchMove, { passive: true });
        mainImage.addEventListener('touchend', handleTouchEnd, { passive: true });
        
        // Empêcher le zoom par défaut sur l'image
        mainImage.addEventListener('gesturestart', (e) => e.preventDefault());
        mainImage.addEventListener('gesturechange', (e) => e.preventDefault());
        
        // Synchroniser l'index actuel avec les miniatures
        syncCurrentIndex();
    }
    
    // Synchroniser l'index actuel avec la miniature active
    function syncCurrentIndex() {
        const activeThumbnail = document.querySelector('.thumbnail-item.active');
        if (activeThumbnail) {
            const thumbnailsArray = Array.from(thumbnails);
            currentImageIndex = thumbnailsArray.indexOf(activeThumbnail);
        }
    }
    
    // Gestion du début du touch
    function handleTouchStart(e) {
        if (!isMobile()) return;
        
        startX = e.touches[0].clientX;
        isSwipping = false;
    }
    
    // Gestion du mouvement tactile
    function handleTouchMove(e) {
        if (!isMobile() || !startX) return;
        
        const currentX = e.touches[0].clientX;
        const diffX = Math.abs(currentX - startX);
        
        // Si le mouvement est assez important, on considère que c'est un swipe
        if (diffX > 10) {
            isSwipping = true;
        }
    }
    
    // Gestion de la fin du touch
    function handleTouchEnd(e) {
        if (!isMobile() || !startX || !isSwipping) {
            startX = 0;
            isSwipping = false;
            return;
        }
        
        const endX = e.changedTouches[0].clientX;
        const diffX = startX - endX;
        
        // Swipe vers la gauche (image suivante)
        if (diffX > swipeThreshold) {
            goToNextImage();
        }
        // Swipe vers la droite (image précédente)
        else if (diffX < -swipeThreshold) {
            goToPrevImage();
        }
        
        startX = 0;
        isSwipping = false;
    }
    
    // Aller à l'image suivante
    function goToNextImage() {
        let newIndex = currentImageIndex + 1;
        
        // Boucle infinie - retour à la première image
        if (newIndex >= totalImages) {
            newIndex = 0;
        }
        
        goToImage(newIndex);
    }
    
    // Aller à l'image précédente
    function goToPrevImage() {
        let newIndex = currentImageIndex - 1;
        
        // Boucle infinie - aller à la dernière image
        if (newIndex < 0) {
            newIndex = totalImages - 1;
        }
        
        goToImage(newIndex);
    }
    
    // Aller à une image spécifique
    function goToImage(index) {
        if (index === currentImageIndex || index < 0 || index >= totalImages) {
            return;
        }
        
        currentImageIndex = index;
        
        // Utiliser votre fonction existante updateMainImage si elle existe
        const targetThumbnail = thumbnails[index];
        if (targetThumbnail) {
            // Simuler un clic sur la miniature pour utiliser votre logique existante
            targetThumbnail.click();
        }
    }
    
    // Écouter les clics sur les miniatures pour synchroniser l'index
    thumbnails.forEach((thumb, index) => {
        thumb.addEventListener('click', function() {
            currentImageIndex = index;
        });
    });
    
    // Gérer le redimensionnement de la fenêtre
    window.addEventListener('resize', function() {
        // Réinitialiser si on change d'orientation ou de taille
        setTimeout(initMobileTouchPagination, 100);
    });
    
    // Initialiser la pagination tactile mobile
    initMobileTouchPagination();
});
